import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/010-upload.png';
const _withScopeId = n => (_pushScopeId("data-v-65c329da"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "batch main"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "batch-header"
}, [/*#__PURE__*/_createElementVNode("h2", {
  class: "batch-title"
}, "批量图片处理"), /*#__PURE__*/_createElementVNode("p", {
  class: "batch-desc"
}, "同时处理多张图片，提高您的工作效率")], -1));
const _hoisted_3 = {
  class: "batch-container"
};
const _hoisted_4 = {
  class: "batch-top"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "upload-content"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "upload-icon",
  src: _imports_0
}), /*#__PURE__*/_createElementVNode("div", {
  class: "el-upload__text"
}, [/*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createTextVNode("将图片拖拽至此，或 "), /*#__PURE__*/_createElementVNode("em", null, "点击上传")]), /*#__PURE__*/_createElementVNode("p", {
  class: "upload-tip"
}, "支持JPG、PNG、WEBP等格式")])], -1));
const _hoisted_6 = {
  class: "file-list"
};
const _hoisted_7 = {
  class: "file-list-header"
};
const _hoisted_8 = {
  class: "file-list-actions"
};
const _hoisted_9 = {
  class: "file-list-content"
};
const _hoisted_10 = {
  class: "file-list-bot"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-download"
}, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_upload = _resolveComponent("el-upload");
  const _component_param_form = _resolveComponent("param-form");
  const _component_el_button = _resolveComponent("el-button");
  const _component_file_item = _resolveComponent("file-item");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_upload, {
    class: "upload",
    drag: "",
    action: $data.baseUrl + 'dcwytimgapi/process/single',
    accept: $data.acceptImageFormats,
    multiple: true,
    "show-file-list": false,
    data: $options.uploadOptions,
    "file-list": $data.fileList,
    "onUpdate:fileList": _cache[0] || (_cache[0] = $event => $data.fileList = $event)
  }, {
    default: _withCtx(() => [_hoisted_5]),
    _: 1
  }, 8, ["action", "accept", "data", "file-list"]), _createVNode(_component_param_form, {
    class: "batch-form",
    type: "multiple",
    form: $data.options
  }, null, 8, ["form"])]), _createVNode(_Transition, {
    name: "fade"
  }, {
    default: _withCtx(() => [_withDirectives(_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("h3", null, "已上传文件 (" + _toDisplayString($data.fileList.length) + ")", 1), _createElementVNode("div", _hoisted_8, [_createVNode(_component_el_button, {
      size: "small",
      onClick: $options.clearFileList,
      icon: "el-icon-delete"
    }, {
      default: _withCtx(() => [_createTextVNode("清空列表")]),
      _: 1
    }, 8, ["onClick"])])]), _createElementVNode("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.fileList, file => {
      return _openBlock(), _createBlock(_component_file_item, {
        file: file,
        key: file.uid
      }, null, 8, ["file"]);
    }), 128))]), _createElementVNode("div", _hoisted_10, [_createVNode(_component_el_button, {
      type: "primary",
      onClick: $options.downloadAll,
      disabled: $data.fileList.length === 0
    }, {
      default: _withCtx(() => [_hoisted_11, _createTextVNode(" 下载全部 ")]),
      _: 1
    }, 8, ["onClick", "disabled"])])], 512), [[_vShow, $data.fileList.length]])]),
    _: 1
  })])]);
}